import axios from "axios";

export const getPortListNoPerm = async () => {
  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/list-order/get-all-order_port_no_and_name`,
      config
    );
    return data?.data?.result;
  } catch (error) {
    return error?.response?.data?.result;
  }
};
export const getPortList = async () => {
  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/port-master/dropdown-port-master`,
      config
    );
    return data?.data?.result;
  } catch (error) {
    return error?.response?.data?.result;
  }
};
